import { Skeleton } from "@mui/material";
import * as Styles from "features/MarketingMaterials/pages/PendingCampaigns/components/Skeletons/ViewCampaignsSkeleton.styles.ts";

export const ViewCampaignsSkeleton = () => {
	return (
		<Styles.ViewCampaignsSkeletonWrapper>
			<Styles.CampaignSkeletonCard>
				<Skeleton
					variant="rectangular"
					height="120px"
				/>
			</Styles.CampaignSkeletonCard>
			<Styles.CampaignSkeletonCard>
				<Skeleton
					variant="rectangular"
					height="120px"
				/>
			</Styles.CampaignSkeletonCard>
		</Styles.ViewCampaignsSkeletonWrapper>
	);
};
